import 'cleave.js'
import Cleave from 'cleave.js'
import 'cleave.js/dist/addons/cleave-phone.ru'

export default new class phoneMask {
    constructor() {
        this.mask = '[data-phone="true"]'

        this.init()
    }

    init() {
      $(this.mask).toArray().forEach(function(field) {
        var cleave = new Cleave(field, {
          phone: true,
          phoneRegionCode: 'ru'
        })
      })
    }
}